import InvoiceGateway from "@/usecases/accounting/invoice-gateway";
import Invoice from "@/usecases/accounting/invoice";
import SaveInvoiceRequest from "@/usecases/accounting/save-invoice-request";
import ClientLike from "../client-like";
import invoiceStatusTranslater from "@/usecases/accounting/invoice-status-translater";

export default class InvoiceApi implements InvoiceGateway {
  public constructor(private client: ClientLike) {}

  public async find(id: number): Promise<Invoice | undefined> {
    const res = await this.client.get("get_invoice.php", { id });
    if (res.invoices.length > 0) {
      return toInvoice(res.invoices[0]);
    }
  }

  public async findAll(
    options: {
      projectId?: string;
      projectName?: string;
      companyId?: string;
      status?: string;
      startDate?: string;
      endDate?: string;
    } = {}
  ): Promise<Invoice[]> {
    const res = await this.client.get("get_invoice.php", options);
    return res.invoices.map(toInvoice);
  }

  public async save(invoice: SaveInvoiceRequest): Promise<number> {
    const data = await this.client.post("save_invoice.php", invoice);
    return data.id;
  }

  public async destroy(id: number): Promise<void> {
    const d = new FormData();
    d.append("id", String(id));
    await this.client.post("delete_invoice.php", d);
  }
}

function toInvoice(data: any): Invoice {
  return {
    ...data,
    statusName: invoiceStatusTranslater.toJp(data.status)
  };
}
